import { render, staticRenderFns } from "./RiskSeverityToolbar.vue?vue&type=template&id=35c80fa8&scoped=true&"
import script from "./RiskSeverityToolbar.vue?vue&type=script&lang=js&"
export * from "./RiskSeverityToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RiskSeverityToolbar.vue?vue&type=style&index=0&id=35c80fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c80fa8",
  null
  
)

export default component.exports